import { render, staticRenderFns } from "./AgentQuickResponse.vue?vue&type=template&id=50b5ca02&scoped=true&"
import script from "./AgentQuickResponse.vue?vue&type=script&lang=js&"
export * from "./AgentQuickResponse.vue?vue&type=script&lang=js&"
import style0 from "./AgentQuickResponse.vue?vue&type=style&index=0&id=50b5ca02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5ca02",
  null
  
)

export default component.exports